import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ProductListRes;
export const ProductListTodo = createAsyncThunk('ProductList', async (data) => {
    console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            // url: process.env.REACT_APP_API_URL + 'product_list',
            url: process.env.REACT_APP_API_URL + 'sales_items_list',
            // data: {
            //     "vcust_plant_code": localStorage.getItem('vcust_plant_code'),
            //     "vitem_name": data && data?.search,
            //     "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
            //     "pageing":data?.pageSize,
            //     "vparent_group_code": "",
            //     "vgroup_code": data?.group,
            //     "ilimit": data?.pageLimit,
            // },

            data: {
                "vmodel_no": data && data?.search,
                "all": "-1",
                "vcust_plant_code": localStorage.getItem('vcust_plant_code'),
                "aj": "0",
                "vitem_allowed": "1",
                "vdate": "",
                "idivision_id": '',
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "vsupplier_code": "",
                "cvendor_po_type": "",
                "iware_house_id": "0",
                "pageing": data?.pageSize.toString(),
                "vparent_group_code": "",
                "vgroup_code": "",
                "ccategeory": data?.group,
                "itype": "1",
                // "page": data && data.pageIndex,
                "ilimit": data?.pageLimit

            },
            headers: { "Content-Type": "application/json" },

        })
        return ProductListRes = res.data

    } catch (error) {
        return ProductListRes = error.response.data
    }
});

const ProductListSlice = createSlice({
    name: 'ProductList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(ProductListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(ProductListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default ProductListSlice.reducer; 